import * as React from 'react';
// @ts-expect-error
import {Switch, Route, ContextRouter} from 'react-router-dom';

import {ForgotPasswordPage} from './forgot-password/forgot-password-page';
import {LoginPage} from './login-page';
import {NewLoginLayout} from './new-login-layout';
import {ResetSuccessPage} from './reset-success/reset-success-page';
import {SetNewPasswordPage} from './set-new-password/set-new-password-page';

/*
 * This is the top-level ui component for pages associated with the login flow
 */
export class LoginRoot extends React.Component<Record<any, any>> {
    render() {
        const pageContent = (
            <Switch>
                <Route path='/auth/forgot-password' component={ForgotPasswordPage} />
                <Route
                    path='/auth/reset-password'
                    render={(props: ContextRouter) => (
                        <SetNewPasswordPage {...props} isNewUser={false} />
                    )}
                />
                <Route path='/auth/reset-success' component={ResetSuccessPage} />
                <Route
                    path='/auth/get-started'
                    render={(props: ContextRouter) => (
                        <SetNewPasswordPage {...props} isNewUser={true} />
                    )}
                />
                <Route path='/auth' exact={true} component={LoginPage} />
            </Switch>
        );

        return <NewLoginLayout form={pageContent} />;
    }
}
